import { computed, onUnmounted, ref } from 'vue';
export default {
  name: 'XTimerButton',
  props: {
    type: {
      type: String,
      default: 'default'
    },
    // 按钮类型
    danger: {
      type: Boolean,
      default: false
    },
    // 是否危险按钮
    loading: {
      type: Boolean,
      default: false
    },
    // 是否显示加载中
    maxSec: {
      type: Number,
      default: 300
    },
    // 最大秒数
    title: {
      type: String,
      default: ''
    },
    timerTitleFormat: {
      type: Function,
      default: time => `${time}后重试`
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['click'],
  setup(props, {
    emit
  }) {
    const seconds = ref(0);
    const btnDisabled = computed(() => {
      return props.disabled || seconds.value > 0;
    });
    const formatSeconds = sec => {
      if (sec >= 3600) {
        // hours
        const hours = Math.floor(sec / 3600);
        sec = sec % 3600;
        const minutes = Math.floor(sec / 60);
        sec = sec % 60;
        return `${hours}小时${minutes}分${sec}秒`;
      } else if (sec >= 60) {
        // minutes
        const hours = Math.floor(sec / 60);
        sec = sec % 60;
        return `${hours}分${sec}秒`;
      }
      return `${sec}秒`;
    };
    const formatTimerTitle = time => {
      if (props.timerTitleFormat) {
        return props.timerTitleFormat(time);
      }
      return `${time}后重试`;
    };
    const btnTitle = computed(() => {
      if (seconds.value <= 0) {
        return props.title;
      }
      const time = formatSeconds(seconds.value);
      return formatTimerTitle(time);
    });
    const timer = ref(0);
    onUnmounted(() => {
      if (timer.value) {
        clearTimeout(timer.value);
        timer.value = 0;
      }
    });

    // 开始倒计时
    const startTimer = () => {
      const _startTimer = () => {
        clearInterval(timer.value);
        if (seconds.value <= 0) {
          seconds.value = 0;
          return;
        }
        seconds.value -= 1;
        timer.value = setTimeout(_startTimer, 1000);
      };
      seconds.value = props.maxSec;
      _startTimer();
    };
    const handleClick = () => {
      if (btnDisabled.value) {
        return;
      }
      startTimer();
      emit('click');
    };
    return {
      btnDisabled,
      btnTitle,
      handleClick
    };
  }
};